// createTriggerPrivateRequest.js
'use strict';
import { MERGE_LIVE_STREAM_DATA } from '../ActionTypes.js';
import submitTriggerPrivateStream from '../action/submitTriggerPrivateStream.js';
import setIsPrivateStreamUnlocked from '../action/setIsPrivateStreamUnlocked.js';
import setPrivateStreamAutoPayment from '../action/setPrivateStreamAutoPayment.js';
import setTriggerPrivateInviteCountdown from '../action/setTriggerPrivateInviteCountdown.js';

import getNetworkingSummary from '../selector/getNetworkingSummary.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';

import {
  GroupPrivateStatus,
  LivestreamTriggerType,
} from '../resource/liveStreamConstants.js';

/**
 * Create trigger private request
 * @kind action
 * @param {string} {streamId} - stream id.
 * @param {LivestreamTriggerType} {triggerType} - trigger type.
 * @return {Promise} Action promise.
 */
const createTriggerPrivateRequest =
  ({ streamId, triggerType } = {}) =>
  async (dispatch, getState) => {
    if (!streamId) return dispatch({ type: '' });

    // Exactly-once guard: the invite is already sent
    const isInviteSubmitted = getLiveStreamData(
      getState(),
      [streamId, 'triggerPrivateInvite'],
      'isInviteSubmitted'
    );
    if (isInviteSubmitted) return dispatch({ type: '' });
    dispatch({
      type: MERGE_LIVE_STREAM_DATA,
      payload: {
        selectPath: [streamId, 'triggerPrivateInvite'],
        data: { isInviteSubmitted: true },
      },
    });

    const sessionId = getLiveStreamData(getState(), [streamId], 'sessionId');
    await dispatch(
      submitTriggerPrivateStream({ sessionId, triggerType, streamId })
    );

    const { status, error } = getNetworkingSummary(getState(), [
      'submit',
      triggerType,
      sessionId,
    ]);
    if ('fetched' === status && !error) {
      dispatch(
        setIsPrivateStreamUnlocked({ streamId, isPrivateStreamUnlocked: true })
      );
      dispatch(
        setPrivateStreamAutoPayment({
          streamId,
          isEnabled: true,
        })
      );
      // Join case:
      // when the group goal already exists (another viewer invitedfirst, status is already CONSIDERING)，no status transition will fire
      // need to clear countdown here
      const isJoiningConsideringGroup =
        LivestreamTriggerType.TRIGGER_PRIVATE === triggerType &&
        GroupPrivateStatus.CONSIDERING ===
          getLiveStreamData(getState(), [streamId, 'groupPrivate'], 'status');
      if (isJoiningConsideringGroup) {
        dispatch(setTriggerPrivateInviteCountdown({ streamId, seconds: null }));
      }
    } else {
      // Submit failed: clear the countdown so the menu reverts to the two buttons.
      dispatch(setTriggerPrivateInviteCountdown({ streamId, seconds: null }));
    }
  };

export default createTriggerPrivateRequest;
